import type { ReactNode } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

interface TabTransitionProps {
  tabKey: string;
  children: ReactNode;
}

export default function TabTransition({ tabKey, children }: TabTransitionProps) {
  return (
    <AnimatePresence mode="popLayout" initial={false}>
      <motion.div
        key={tabKey}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.12, ease: 'easeOut' }}
        style={{ overflow: 'visible' }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
